import React from "react";
import PosJournalDetail from "../component/PosJournalDetail";

const PosJournalDetailContainer = ({ pageId }) => (<PosJournalDetail pageId={ pageId } />)

export default PosJournalDetailContainer;
